import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../common/Header";
import $ from "jquery";
import useAuth from "../../hooks/useAuth";
import { GETREQUEST } from "../helpers/ServiceRequest";

function UsersList() {
  const [users, setUsers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [current, setCurrent] = useState("");
  const [totalPages, setTotalPages] = useState();
  const [totalItems, setTotalItems] = useState();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [currentPage, setCurrentPage] = useState();
  const [loading, setLoading] = useState(true);

  const { user } = useAuth();

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      let URL =
        process.env.REACT_APP_API_URL + `/get-users?page=${page}&size=${size}`;
      if (current != "" && searchText != "") {
        URL = URL + `&current=${current}&searchText=${searchText}`;
      } else if (current != "") {
        URL = URL + `&current=${current}`;
      } else if (searchText != "") {
        URL = URL + `&searchText=${searchText}`;
      }
      let response = await GETREQUEST(URL, user.jwtToken, false);
      if (response?.data) {
        setLoading(false);
        setUsers(response.data.data);
        setTotalPages(response.data.totalPages);
        setTotalItems(response.data.totalItems);
        setCurrentPage(response.data.currentPage);
      }
    }
    fetchData();
  }, [searchText, current, page]);

  return (
    <React.Fragment>
      <Header />
      <main>
        <section className="p-4 overflow-hidden table-listing">
          <div className="table-elements">
            <div className="paginations">
              <p className="float-start fs-14 text-lite mb-1 me-2">
                Showing Results{" "}
                <span className="text-dark">{totalItems == 0 ? 0 : 1}</span> -{" "}
                <span className="text-dark">{users.length}</span> of{" "}
                <span className="text-dark">{totalItems}</span>
              </p>
              <ul className="list-inline mb-2">
                {currentPage > 0 && (
                  <li className="list-inline-item">
                    <a onClick={() => setPage(page - 1)}>
                      {" "}
                      <i className="bi bi-chevron-left text-light"></i>{" "}
                    </a>
                  </li>
                )}
                {totalPages > currentPage + 1 && (
                  <li className="list-inline-item">
                    <a onClick={() => setPage(page + 1)}>
                      {" "}
                      <i className="bi bi-chevron-right text-dark"></i>{" "}
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div className="card border-bottom-0 w-100">
            <div className="card-header bg-white d-flex align-items-center align-items-start justify-content-between cpx-20 cpy-14 sticky-top flex-nowrap overflow-auto">
              <h1 className="title-semibold fs-24 mb-0 d-flex align-items-center text-nowrap me-5 me-xl-0">
                Users
              </h1>
              <div className="filter-elements d-flex align-items-center">
                <div className="input-group flex-nowrap cme-10 me-0">
                  <div
                    type="button"
                    className="btn btn-outline-light hover-none border-end-0 d-flex align-items-center pe-0"
                  >
                    <i className="bi bi-search"></i>
                  </div>
                  <input
                    type="text"
                    className="form-control input-sm border-start-0 search"
                    placeholder="Search by User Name"
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div className="custom-group flex-nowrap">
                  <select
                    className="form-select input-sm cme-10"
                    aria-label="Default select example"
                    style={{ width: "168px" }}
                    onChange={(e) => setCurrent(e.target.value)}
                  >
                    <option value="">Select Status</option>
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                  </select>
                  <Link
                    to="/create-user"
                    className="btn btn-sm btn-secondary d-flex align-items-center text-nowrap px-3 fw-medium text-white rounded-3"
                  >
                    <i className="icon icon-add cpe-5 fs-13"></i>Add User
                  </Link>
                </div>
              </div>
            </div>
            <div className="card-body p-0 border-bottom">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead>
                    <tr>
                      <th scope="col" className="col width-sm-auto">
                        User Name
                      </th>
                      <th scope="col" className="col width-sm-auto">
                        Email
                      </th>
                      <th scope="col" className="col width-sm-auto">
                        Role
                      </th>
                      <th scope="col" className="width-lg-6 width-sm-auto">
                        Status
                      </th>
                      <th scope="col" className="width-lg-6 width-sm-auto">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="position-relative">
                    {loading && (
                      <tr className="position-absolute w-100 ">
                        <td className="bg-white w-100 d-flex justify-content-center align-items-center p-1 border-0">
                          <div className="overlay">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {users.length == 0 && (
                      <tr>
                        <td colSpan={5} className="text-center">
                          No Record Found
                        </td>
                      </tr>
                    )}
                    {users.map((user, index) => {
                      return (
                        <tr key={index}>
                          <td>{user.UserName}</td>
                          <td>{user.Email}</td>
                          <td>{user.Role}</td>
                          <td>
                            <span
                              className={
                                "badge statusBadge border  fw-medium  px-4 fs-13 cpy-7 " +
                                (user.Current === 1
                                  ? "border-success text-success bg-success-lite"
                                  : "border-warning text-warning bg-warning-lite")
                              }
                            >
                              {user.Current === 1 ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td>
                            <Link
                              to={"/update-user/" + user.UserID}
                              className="btn btn-outline-lite btn-xs d-inline-flex align-items-center text-dark"
                            >
                              View/Edit
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}

export default UsersList;
